import {Field} from "./Field";

export class TextField extends Field<string> {
    stringValue = (): string | undefined => {
        if (this.value) {
            return this.value.toString();
        }
        return undefined
    };
}